export const handleLoginPages = (loginState) => {
    const publicRoutes = ["", "login", "schedule", "live", "privacy", "manual"];
    const hash = window.location.hash.replace(/^#\/?/, ""); // Remove leading #/
    const segments = hash.split("/").filter(Boolean);

    const isPublic =
        segments.length === 0 ||
        (publicRoutes.includes(segments[0]) || (segments.length === 1 && isNumeric(segments[0])) || (segments.length === 2 && isNumeric(segments[0]) && publicRoutes.includes(segments[1])));

    if (!loginState && !isPublic) {
        navigateToPage(`login`);
    }
}

export const handleClubDataPages = (clubData, dialogState) => {
    if (!clubData) {
        if (window.location.hash.replace(/^#\/?/, "").endsWith("create-account")) return;

        dialogState(true);
    }
}

export const checkLoginPage = () => {
    if (window.location.href.includes("?")) return;

    window.location.href = `?#/login`;
}

export const navigateToPage = (path) => {
    if (window.location.href.includes(`?`)) {
        if (window.location.href.includes(`login`)) {
            window.location.href = window.location.href.replace(`?#/login`, '') + `#/${path}`;
            return;
        }
        window.location.href = window.location.href.replace(`?`, '');
    }

    window.location.hash = `#/${path}`;
}

function isNumeric(num){
    return !isNaN(num)
}